import { useState, useEffect, createContext } from 'react'
import { extent } from 'd3-array'
import { useFetch } from '../hooks/useFetch'
import { BASE_URL } from '../utils/constants'
//import { lang } from '../utils/lang'

export const DataContext = createContext()

export const DataProvider = ({ children }) => {
  const [ui, setUi] = useState('fa') // sets ui lang
  const uiLang = ui === 'fa' ? 'fa/' : ''
  const [query, setQuery] = useState(
    `${BASE_URL}/${uiLang}omiddata/getperson?viol_id=21&fields=fnames,sname,age,viol_startdate,viol_full_placename,viol_coordinates,photo_id,was_arrest,was_prosecution`
  )

  const [nonFatalQuery, setNonFatalQuery] = useState(
    `${BASE_URL}/${uiLang}omiddata/getperson?nonfatal=1&fields=fnames,sname,age,viol_startdate,viol_full_placename,viol_coordinates,photo_id,was_arrest,was_prosecution,non_fatal`
  )

  useEffect(() => {
    setQuery(
      `${BASE_URL}/${uiLang}omiddata/getperson?viol_id=21&fields=fnames,sname,age,viol_startdate,viol_full_placename,viol_coordinates,photo_id,was_arrest,was_prosecution`
    )
    setNonFatalQuery(
      `${BASE_URL}/${uiLang}omiddata/getperson?nonfatal=1&fields=fnames,sname,age,viol_startdate,viol_full_placename,viol_coordinates,photo_id,was_arrest,was_prosecution,non_fatal`
    )
  }, [ui, uiLang])

  const { loading, data, error } = useFetch(query)
  const {
    loading: nonFatalLoading,
    data: nonFatalData,
    error: nonFatalError
  } = useFetch(nonFatalQuery)

  const [formattedData, setFormattedData] = useState()
  const [formattedNonFatalData, setFormattedNonFatalData] = useState()

  const [years, setYears] = useState()
  const [selections, setSelections] = useState({
    Religion: 'ALL',
    Occupation: 'ALL',
    Education: 'ALL',
    Gender: 'ALL',
    'Threats or failed attempts': 'ALL',
    'Modes of killing': 'ALL',
    Arrests: 'ALL',
    Prosecution: 'ALL'
  })
  const queryParams = new URLSearchParams(window.location.search)
  const param = queryParams.get('intro')
  //console.log('param', param)
  //this covers if param is open or undefined (llike when app first loads), it will be open, else closed
  const [intro, setIntro] = useState(param === 'closed' ? 'closed' : 'open')
  // const [names, setNames] = useState({ en: [], fa: [] })

  useEffect(() => {
    // const getDate = (digitsAsString) => {
    //   if (digitsAsString === '00') {
    //     return null
    //   } else if (digitsAsString.startsWith('0')) {
    //     return digitsAsString.slice(1)
    //   } else return digitsAsString
    // }
    const processData = (data, nonFatalData) => {
      const yearArray = []
      const dataArray = []
      const nonFatalDataArray = []

      for (const [key, value] of Object.entries(data)) {
        dataArray.push({
          id: +key,
          fnames: value.fnames,
          sname: value.sname,
          age: value.age,
          location: value.viol_full_placename,
          //month: value.viol_startdate ? value.viol_startdate.slice(4, 6) : null,
          //day: value.viol_startdate
          //  ? getDate(value.viol_startdate.slice(6, 8))
          //  : null,
          date: value.viol_startdate ? value.viol_startdate : null,
          year: value.viol_startdate ? value.viol_startdate.slice(0, 4) : null,
          coordinates: value.viol_coordinates ? value.viol_coordinates : null,
          photoUrlLg: value.photo_id
            ? `${BASE_URL}/actorphotos/${value.photo_id}.png`
            : null,
          photoUrlSm: value.photo_id
            ? `${BASE_URL}/actorphotos/${value.photo_id}_thumb.jpeg `
            : null,
          arrested: +value.was_arrest,
          prosecuted: +value.was_prosecution
        })
        yearArray.push(
          value.viol_startdate && value.viol_startdate !== '0'
            ? value.viol_startdate.slice(0, 4)
            : null
        )
      }

      for (const [key, value] of Object.entries(nonFatalData)) {
        value.non_fatal.forEach((threat, i) => {
          nonFatalDataArray.push({
            id: +key,
            fnames: value.fnames,
            sname: value.sname,
            age: value.age,
            location: value.non_fatal[i].viol_loca,
            date: value.non_fatal[i].viol_startdate,
            year: value.non_fatal[i].viol_startdate
              ? value.non_fatal[i].viol_startdate.slice(0, 4)
              : null,
            coordinates: value.non_fatal[i].viol_coordinates
              ? value.non_fatal[i].viol_coordinates
              : null,
            photoUrlLg: value.photo_id
              ? `${BASE_URL}/actorphotos/${value.photo_id}.png`
              : null,
            photoUrlSm: value.photo_id
              ? `${BASE_URL}/actorphotos/${value.photo_id}_thumb.jpeg `
              : null,
            arrested: +value.was_arrest,
            prosecuted: +value.was_prosecution,
            nonFatal: value.non_fatal[i]
          })
        })
      }

      return { dataArray, yearArray, nonFatalDataArray }
    }
    if (data && nonFatalData) {
      const d = processData(data, nonFatalData)
      setFormattedData(d.dataArray)
      setFormattedNonFatalData(d.nonFatalDataArray)
      setYears(extent(d.yearArray))
    }
  }, [data, nonFatalData, ui])

  return (
    <DataContext.Provider
      value={{
        ui,
        setUi,
        formattedData,
        setFormattedData,
        formattedNonFatalData,
        setFormattedNonFatalData,
        years,
        error,
        loading,
        nonFatalError,
        nonFatalLoading,
        query,
        setQuery,
        nonFatalQuery,
        setNonFatalQuery,
        intro,
        setIntro,
        selections,
        setSelections
        // names
      }}
    >
      {children}
    </DataContext.Provider>
  )
}
